var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-top-dashboard',{attrs:{"primary":""}}),_c('v-container',{staticClass:"pt-0 px-6 mt-n16",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"mt-n3",attrs:{"cols":"12"}},[_c('paginated-table')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }